// quick-add.js

if (!customElements.get('quick-add-modal')) {
    customElements.define(
      'quick-add-modal',
      class QuickAddModal extends ModalDialog {
        constructor() {
          super();
          // constructorではmodalContentを取得しない
        }
  
        connectedCallback() {
          // 要素がDOMに繋がったタイミングでmodalContentを取得
          this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        }
  
        hide(preventFocus = false) {
          const cartNotification =
            document.querySelector('cart-notification') ||
            document.querySelector('cart-drawer');
          if (cartNotification) cartNotification.setActiveElement(this.openedBy);
  
          // 内容リセット
          if (this.modalContent) {
            this.modalContent.innerHTML = '';
          }
  
          if (preventFocus) this.openedBy = null;
          super.hide();
        }
  
        show(opener) {
          opener.setAttribute('aria-disabled', true);
          opener.classList.add('loading');
          opener.querySelector('.loading__spinner')?.classList.remove('hidden');
  
          // safety: modalContentがまだ取れていなければここで取得
          if (!this.modalContent) {
            this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
          }
  
          fetch(opener.getAttribute('data-product-url'))
            .then((response) => response.text())
            .then((responseText) => {
              const responseHTML = new DOMParser().parseFromString(
                responseText,
                'text/html'
              );
  
              // productElementを複数パターンで取得
              this.productElement =
                responseHTML.querySelector('section[id^="MainProduct-"]') ||
                responseHTML.querySelector('main[id^="MainProduct-"]') ||
                responseHTML.querySelector('[data-section-type="product"]');
  
              if (!this.productElement) {
                console.error('QuickAddModal: productElement が見つかりません');
                return;
              }
  
              // クラスを安全にループしてmodalContentに転写
              const classes = Array.from(this.productElement.classList);
              classes.forEach((classApplied) => {
                if (
                  (typeof classApplied === 'string' &&
                    (classApplied.startsWith('color-') ||
                      classApplied === 'gradient')) &&
                  this.modalContent
                ) {
                  this.modalContent.classList.add(classApplied);
                }
              });
  
              this.preventDuplicatedIDs();
              this.removeDOMElements();
  
              // innerHTMLをセット（scriptタグも再実行）
              this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
  
              // Shopifyの追加ボタン再初期化
              if (window.Shopify && Shopify.PaymentButton) {
                Shopify.PaymentButton.init();
              }
              if (window.ProductModel) {
                window.ProductModel.loadShopifyXR();
              }
  
              this.removeGalleryListSemantic();
              this.updateImageSizes();
              this.preventVariantURLSwitching();
  
              super.show(opener);
            })
            .catch((err) => console.error('QuickAdd fetch error:', err))
            .finally(() => {
              opener.removeAttribute('aria-disabled');
              opener.classList.remove('loading');
              opener
                .querySelector('.loading__spinner')
                ?.classList.add('hidden');
            });
        }
  
        setInnerHTML(element, html) {
          element.innerHTML = html;
          element.querySelectorAll('script').forEach((oldScriptTag) => {
            const newScriptTag = document.createElement('script');
            Array.from(oldScriptTag.attributes).forEach((attribute) => {
              newScriptTag.setAttribute(attribute.name, attribute.value);
            });
            newScriptTag.appendChild(
              document.createTextNode(oldScriptTag.innerHTML)
            );
            oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
          });
        }
  
        preventVariantURLSwitching() {
          const variantPicker =
            this.modalContent?.querySelector('variant-selects');
          if (!variantPicker) return;
          variantPicker.setAttribute('data-update-url', 'false');
        }
  
        removeDOMElements() {
          if (!this.productElement) return;
  
          const pickupAvailability =
            this.productElement.querySelector('pickup-availability');
          if (pickupAvailability) pickupAvailability.remove();
  
          const productModal =
            this.productElement.querySelector('product-modal');
          if (productModal) productModal.remove();
  
          const modalDialogs =
            this.productElement.querySelectorAll('modal-dialog');
          modalDialogs.forEach((modal) => modal.remove());
        }
  
        preventDuplicatedIDs() {
          if (!this.productElement) return;
          const sectionId = this.productElement.dataset.section;
          this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
            sectionId,
            `quickadd-${sectionId}`
          );
          this.productElement
            .querySelectorAll('variant-selects, product-info')
            .forEach((el) => {
              el.dataset.originalSection = sectionId;
            });
        }
  
        removeGalleryListSemantic() {
          const galleryList =
            this.modalContent?.querySelector('[id^="Slider-Gallery"]');
          if (!galleryList) return;
          galleryList.setAttribute('role', 'presentation');
          galleryList
            .querySelectorAll('[id^="Slide-"]')
            .forEach((li) => li.setAttribute('role', 'presentation'));
        }
  
        updateImageSizes() {
          const productEl = this.modalContent?.querySelector('.product');
          if (!productEl) return;
          const desktopColumns = productEl.classList.contains(
            'product--columns'
          );
          if (!desktopColumns) return;
  
          const mediaImages = productEl.querySelectorAll('.product__media img');
          if (!mediaImages.length) return;
  
          let mediaImageSizes =
            '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
  
          if (productEl.classList.contains('product--medium')) {
            mediaImageSizes = mediaImageSizes.replace('715px', '605px');
          } else if (productEl.classList.contains('product--small')) {
            mediaImageSizes = mediaImageSizes.replace('715px', '495px');
          }
  
          mediaImages.forEach((img) => {
            img.setAttribute('sizes', mediaImageSizes);
          });
        }
      }
    );
  }
  